// css =>
import "../../BaseStructure.css";
import Styled from "./orderBox.module.css";

// type =>
import ORDER_BOX_TYPE from "./orderBoxType";

// react =>
import { useNavigate } from "react-router-dom";

function OrderBox({ orderKey, orderDate, orderTime, orderPaymentStatus, orderStatus, orderCode, items }: ORDER_BOX_TYPE) {

    const navigate = useNavigate();

    return (
        <div className={ Styled.ItemBox } data-aos="fade-up">
            <div className={`row ${ Styled.OrderInfoBox }`}>
                <div className={`col-1 ${ Styled.OrderKeyBox }`}>
                    <p>{ orderCode }</p>
                </div>

                <div className={`col-10 ${ Styled.OrderBody }`}>
                    <div className="col-2" onClick={() => {
                        navigate("/order-details", {
                            state: {
                                orderId: orderCode
                            }
                        });
                    }}>
                        <p style={{ color: 'rgb(0, 170, 255)' }}>مشاهده</p>
                    </div>
                    <div className="col-2">
                        <p>{ orderDate }</p>
                    </div>
                    <div className="col-2">
                        <p>{ orderTime }</p>
                    </div>
                    <div className="col-2">
                        <p style={{ color: 'rgb(0, 178, 30)' }}>{ orderPaymentStatus }</p>
                    </div>
                    <div className="col-2">
                        <p style={{ color: 'rgb(0, 178, 30)' }}>{ orderStatus }</p>
                    </div>
                    <div className="col-2">
                        <p>09141234567</p>
                    </div>
                </div>

                <div className={`col-1 ${ Styled.OrderCodeBox }`}>
                    <p>{ orderKey }</p>
                </div>
            </div>

            <div className={`row ${ Styled.OrderInfoBoxMobile }`}>
                <div className={`col-11 ${ Styled.ProductInfoSectionFrame } `}>
                    <div className={`row ${ Styled.ProductInfoSection } `}>
                        <div className="col-6">
                            <p>جزئیات بسته : </p>
                            <p
                                className={ Styled.ZeroMarginRightP }
                                style={{ color: 'rgb(0, 170, 255)' }}
                                onClick={() => {
                                    navigate("/order-details", {
                                        state: {
                                            orderId: orderCode
                                        }
                                    });
                                }}
                            > مشاهده </p>
                        </div>
                        <div className="col-6">
                            <p>وضعیت پرداخت : </p>
                            <p className={ Styled.ZeroMarginRightP } style={{ color: 'rgb(0, 178, 30)' }}>{ orderPaymentStatus }</p>
                        </div>

                        <div className="col-6">
                            <p>تاریخ خرید : </p>
                            <p className={ Styled.ZeroMarginRightP }>{ orderDate }</p>
                        </div>
                        <div className="col-6">
                            <p>ساعت خرید : </p>
                            <p className={ Styled.ZeroMarginRightP }>{ orderTime }</p>
                        </div>

                        <div className="col-12">
                            <p>وضغیت بسته : </p>
                            <p className={ Styled.ZeroMarginRightP } style={{ color: 'rgb(0, 178, 30)' }}>{ orderStatus }</p>
                        </div>

                        <div className="col-12">
                            <p>پیگیری : </p>
                            <p className={ Styled.ZeroMarginRightP }>09141234567</p>
                        </div>
                    </div>
                </div>

                <div className={`col-1 ${ Styled.OrderCodeFrame } `}>
                    <div className="col-12">
                        <p>کد پیگیری</p>
                        <p>{ orderCode }</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderBox;
